// extracted by mini-css-extract-plugin
export default {"settings":"buttons_settings__+o4kP","faq":"buttons_faq__F-c+D","supportIcon":"buttons_supportIcon__eGK+X","supportButton":"buttons_supportButton__7ENhF"};